/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled'
import { COLOR_PALETTE } from '../../../theme/colors'

const Paragraph = styled.p`
    color: ${COLOR_PALETTE.gray_5};
`

export { Paragraph }
